import(/* webpackMode: "eager" */ "/tmpl-test/app/global-error.tsx")